var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.508,
    height: 14.973,
    viewBox: "0 0 16.508 14.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled_Line",
    "data-name": "Filled Line",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M18.518,10.495,15.447,7.423a.576.576,0,0,0-.814.814l2.089,2.089H5.826a.576.576,0,1,0,0,1.152h10.9l-2.089,2.089a.576.576,0,0,0,.814.814l3.071-3.071a.576.576,0,0,0,0-.814Z",
    transform: "translate(-2.179 -3.415)",
    fill: "#67E1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M11.04,13a.584.584,0,0,0-.576.576v1.536a.96.96,0,0,1-.96.96H3.362a.96.96,0,0,1-.96-.96V4.362a.96.96,0,0,1,.96-.96H9.5a.96.96,0,0,1,.96.96V5.9a.576.576,0,1,0,1.152,0V4.362A2.112,2.112,0,0,0,9.5,2.25H3.362A2.112,2.112,0,0,0,1.25,4.362v10.75a2.112,2.112,0,0,0,2.112,2.112H9.5a2.112,2.112,0,0,0,2.112-2.112V13.576A.584.584,0,0,0,11.04,13Z",
    transform: "translate(-1.25 -2.25)",
    fill: "#67E1AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.86a265606623cfd779411d13868875c6.svg";
export { ForwardRef as ReactComponent };